import { BrowserName } from '@/constants/services'

export const copyToClipboard = (text: string): Promise<void> => navigator.clipboard.writeText(text)

export const getIsTouch = (): boolean => Boolean('ontouchstart' in document.documentElement)

export const getBrowserName = (): BrowserName => {
  const userAgent = navigator.userAgent
  const browsers = [
    { search: 'Firefox', name: BrowserName.firefox },
    { search: 'SamsungBrowser', name: BrowserName.samsung },
    { search: 'Opera', name: BrowserName.opera },
    { search: 'OPR', name: BrowserName.opera },
    { search: 'Trident', name: BrowserName.explorer },
    { search: 'Edge', name: BrowserName.edgeold },
    { search: 'Edg', name: BrowserName.edge },
    { search: 'Chrome', name: BrowserName.chromium },
    { search: 'Safari', name: BrowserName.safari }
  ]

  const browser = browsers.find(({ search }) => userAgent.indexOf(search) !== -1) ?? { name: BrowserName.unknown }

  return browser.name
}
